var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('ul',[_vm._l((_vm.users),function(user){return [_c('User',{key:user.id,attrs:{"user":user}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }